import React from 'react'
import { Badge } from 'reactstrap'
import IToken from '../../images/token.png'
import { NAME_TOKEN } from '../../constants'
import { ITransection } from '../../models/bonus.interface'

interface IProps {
  totalBonus: number
  transection: ITransection[]
}

const ListItems = ({ totalBonus, transection }: IProps) => {
  return (
    <div className='list-items'>
      <div className='list-items--header'>
        <label>Bonus list</label>
        <span>total: {totalBonus}</span>
      </div>
      <ul className='list-items--content'>
        {transection.map((item) => {
          return item.status ? (
            <li className='items' key={`bonus-item-${item.id}`}>
              <div className='items--title'>
                {/** row */}
                <div className='item-left'>
                  {/** row */}
                  <div className='icon-token'>
                    <img className='img-token' alt='' src={IToken} />
                    <div
                      className={`text-token ${
                        item.isClaim ? 'active' : 'inactive'
                      }`}
                    >
                      {NAME_TOKEN}
                    </div>
                  </div>

                  <Badge>{item.airDropRate}x Bonus</Badge>
                </div>

                <span
                  className={`text-bonus ${
                    item.isClaim ? 'active' : 'inactive'
                  }`}
                >
                  {item.airDropValue}
                </span>
              </div>
              <div
                className={`items--description ${
                  item.isClaim ? 'active' : 'inactive'
                }`}
              >
                {item.description}
              </div>
            </li>
          ) : null
        })}
      </ul>
    </div>
  )
}

export default ListItems
